import React from 'react'
import {
  Box,
  Button,
  Grid,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material'
import { ValidationMessageHelper } from './ValidationMessageHelper'

interface ActionButtonsProps {
  canExecuteRelocate: boolean
  onPrev: () => void
  onNext: () => void
  originValidated: boolean
  quantityValidated: boolean
  destinyValidated: boolean
  requiresComments: boolean
  documentNumber?: string
  observations?: string
}

export const ActionButtons: React.FC<ActionButtonsProps> = ({
  canExecuteRelocate,
  onPrev,
  onNext,
  originValidated,
  quantityValidated,
  destinyValidated,
  requiresComments,
  documentNumber,
  observations
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const validationMessage = (
    <ValidationMessageHelper
      originValidated={originValidated}
      quantityValidated={quantityValidated}
      destinyValidated={destinyValidated}
      requiresComments={requiresComments}
      documentNumber={documentNumber}
      observations={observations}
    />
  )

  if (isMobile) {
    return (
      <Box>
        {!canExecuteRelocate && (
          <Box mb={2} textAlign="center">
            <Typography
              variant="body2"
              style={{ color: '#ff9800', fontWeight: 500 }}
            >
              {validationMessage}
            </Typography>
          </Box>
        )}

        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Button
              variant="outlined"
              onClick={onPrev}
              size="small"
              fullWidth
              style={{ height: '36px', fontSize: '0.75rem', minWidth: 0 }}
            >
              Volver a Iniciar
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              variant="contained"
              color="secondary"
              onClick={onNext}
              disabled={!canExecuteRelocate}
              size="small"
              fullWidth
              style={{
                backgroundColor: canExecuteRelocate
                  ? theme.palette.success.main
                  : theme.palette.grey[400],
                height: '36px',
                fontSize: '0.75rem',
                minWidth: 0
              }}
            >
              {canExecuteRelocate ? 'Continuar' : 'Complete los datos'}
            </Button>
          </Grid>
        </Grid>
      </Box>
    )
  }

  return (
    <Box display="flex" justifyContent="space-between" alignItems="flex-end">
      <Button
        variant="outlined"
        onClick={onPrev}
        size="large"
        style={{ minHeight: '48px' }}
      >
        Volver a Iniciar
      </Button>

      <Box display="flex" flexDirection="column" alignItems="flex-end">
        {!canExecuteRelocate && (
          <Typography
            variant="caption"
            style={{
              color: '#ff9800',
              marginBottom: 8,
              textAlign: 'right',
              fontWeight: 500
            }}
          >
            {validationMessage}
          </Typography>
        )}

        <Button
          variant="contained"
          color="secondary"
          onClick={onNext}
          disabled={!canExecuteRelocate}
          size="large"
          style={{
            backgroundColor: canExecuteRelocate ? '#4caf50' : '#ccc',
            minWidth: '200px',
            minHeight: '48px'
          }}
        >
          {canExecuteRelocate ? 'Continuar' : 'Complete los datos'}
        </Button>
      </Box>
    </Box>
  )
}
